export interface Manga {
  id: string;
  title: string;
  author: string;
  cover: string;
  category: string;
  status: '连载中' | '已完结';
  description: string;
  rating: number;
  views: number;
  chapters: Chapter[];
  tags: string[];
  updatedAt: string;
}

export interface Chapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
  pages: number;
}

export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  { slug: 'all', name: '全部', icon: 'ri-apps-2-line', description: '浏览全部漫画作品' },
  { slug: 'rexue', name: '热血', icon: 'ri-fire-line', description: '激情澎湃的热血漫画' },
  { slug: 'lianai', name: '恋爱', icon: 'ri-heart-line', description: '甜蜜浪漫的恋爱漫画' },
  { slug: 'qihuan', name: '奇幻', icon: 'ri-magic-line', description: '天马行空的奇幻漫画' },
  { slug: 'xuanyi', name: '悬疑', icon: 'ri-search-eye-line', description: '扣人心弦的悬疑漫画' },
  { slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-line', description: '轻松幽默的搞笑漫画' },
  { slug: 'kehuan', name: '科幻', icon: 'ri-rocket-line', description: '未来世界的科幻漫画' },
  { slug: 'wuxia', name: '武侠', icon: 'ri-sword-line', description: '快意恩仇的武侠漫画' },
  { slug: 'kongbu', name: '恐怖', icon: 'ri-ghost-line', description: '惊悚刺激的恐怖漫画' },
];

export const mangas: Manga[] = [
  {
    id: 'dongdong-zahuopu',
    title: '洞洞杂货铺',
    author: '猫小乐',
    cover: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20illustration%20of%20a%20mysterious%20antique%20shop%20with%20warm%20amber%20lighting%2C%20wooden%20shelves%20filled%20with%20curious%20items%2C%20a%20young%20shopkeeper%20with%20round%20glasses%20in%20the%20doorway%2C%20manga%20art%20style%20with%20clean%20linework%2C%20warm%20orange%20and%20brown%20tones%2C%20soft%20atmospheric%20lighting%2C%20vintage%20Japanese%20shop%20aesthetic&width=600&height=800&seq=manga-dongdong&orientation=portrait',
    category: 'qihuan',
    status: '连载中',
    description: '在城市的一角，有一家不起眼的杂货铺。但这里卖的不是普通商品，而是能实现愿望的神奇物品。少年阿洞继承了爷爷的杂货铺后，发现每个商品背后都藏着一个动人的故事。跟随阿洞的脚步，一起探索这间神秘杂货铺的秘密吧！洞洞杂货铺不仅是一部奇幻漫画，更是一部关于人性与选择的故事。',
    rating: 9.6,
    views: 1285000,
    tags: ['奇幻', '治愈', '日常', '少年'],
    updatedAt: '2026-08-04',
    chapters: [
      { id: 'ch-1', title: '第一话：爷爷的杂货铺', number: 1, updatedAt: '2025-01-15', pages: 32 },
      { id: 'ch-2', title: '第二话：第一位客人', number: 2, updatedAt: '2025-01-22', pages: 28 },
      { id: 'ch-3', title: '第三话：许愿蜡烛', number: 3, updatedAt: '2025-02-01', pages: 30 },
      { id: 'ch-4', title: '第四话：神秘的老照片', number: 4, updatedAt: '2025-02-15', pages: 26 },
      { id: 'ch-5', title: '第五话：雨天来客', number: 5, updatedAt: '2025-03-01', pages: 35 },
      { id: 'ch-6', title: '第六话：记忆罐头', number: 6, updatedAt: '2025-03-20', pages: 29 },
      { id: 'ch-7', title: '第七话：镜中的世界', number: 7, updatedAt: '2025-04-10', pages: 33 },
      { id: 'ch-8', title: '第八话：时光沙漏', number: 8, updatedAt: '2025-05-01', pages: 31 },
      { id: 'ch-9', title: '第九话：不速之客', number: 9, updatedAt: '2025-05-20', pages: 27 },
      { id: 'ch-10', title: '第十话：爷爷的秘密', number: 10, updatedAt: '2025-06-10', pages: 34 },
      { id: 'ch-11', title: '第十一话：命运的齿轮', number: 11, updatedAt: '2025-07-01', pages: 30 },
      { id: 'ch-12', title: '第十二话：新的开始', number: 12, updatedAt: '2025-07-25', pages: 28 },
      { id: 'ch-13', title: '第十三话：迷路的灵魂', number: 13, updatedAt: '2025-08-15', pages: 32 },
      { id: 'ch-14', title: '第十四话：守护之心', number: 14, updatedAt: '2025-09-10', pages: 29 },
      { id: 'ch-15', title: '第十五话：真相大白', number: 15, updatedAt: '2025-10-05', pages: 36 },
      { id: 'ch-16', title: '第十六话：重逢之日', number: 16, updatedAt: '2025-11-01', pages: 31 },
      { id: 'ch-17', title: '第十七话：新的旅程', number: 17, updatedAt: '2025-12-01', pages: 28 },
      { id: 'ch-18', title: '第十八话：黑暗中的光', number: 18, updatedAt: '2026-01-10', pages: 33 },
      { id: 'ch-19', title: '第十九话：选择的代价', number: 19, updatedAt: '2026-02-20', pages: 30 },
      { id: 'ch-20', title: '第二十话：永不放弃', number: 20, updatedAt: '2026-03-15', pages: 35 },
      { id: 'ch-21', title: '第二十一话：传承', number: 21, updatedAt: '2026-04-10', pages: 32 },
      { id: 'ch-22', title: '第二十二话：暴风雨前', number: 22, updatedAt: '2026-05-05', pages: 28 },
      { id: 'ch-23', title: '第二十三话：宿命对决', number: 23, updatedAt: '2026-06-01', pages: 34 },
      { id: 'ch-24', title: '第二十四话：破晓', number: 24, updatedAt: '2026-07-01', pages: 30 },
      { id: 'ch-25', title: '第二十五话：新的篇章', number: 25, updatedAt: '2026-08-04', pages: 33 },
    ],
  },
  {
    id: 'jianyu-fengbao',
    title: '剑与风暴',
    author: '林风',
    cover: 'https://readdy.ai/api/search-image?query=A%20dynamic%20manga%20cover%20featuring%20a%20warrior%20holding%20a%20glowing%20sword%20against%20a%20stormy%20sky%2C%20epic%20fantasy%20art%20style%2C%20dramatic%20lightning%20in%20the%20background%2C%20warm%20orange%20and%20silver%20color%20palette%2C%20manga%20illustration%20with%20bold%20action%20lines%2C%20heroic%20composition&width=600&height=800&seq=manga-sword-storm&orientation=portrait',
    category: 'wuxia',
    status: '连载中',
    description: '在剑与魔法的世界里，少年剑客林云背负着家族的秘密，踏上了寻找传说中"风暴之剑"的旅程。一路上，他结识了志同道合的伙伴，也遇到了强大的敌人。当黑暗势力席卷大陆，他能否成为传说中的勇者？',
    rating: 9.3,
    views: 856000,
    tags: ['武侠', '热血', '冒险', '友情'],
    updatedAt: '2026-08-03',
    chapters: [
      { id: 'ch-1', title: '第一话：启程之日', number: 1, updatedAt: '2025-03-01', pages: 30 },
      { id: 'ch-2', title: '第二话：风暴来临', number: 2, updatedAt: '2025-03-15', pages: 28 },
      { id: 'ch-3', title: '第三话：剑之试炼', number: 3, updatedAt: '2025-04-01', pages: 32 },
      { id: 'ch-4', title: '第四话：伙伴集结', number: 4, updatedAt: '2025-04-20', pages: 29 },
      { id: 'ch-5', title: '第五话：黑暗觉醒', number: 5, updatedAt: '2025-05-10', pages: 35 },
      { id: 'ch-6', title: '第六话：王者之剑', number: 6, updatedAt: '2025-06-01', pages: 31 },
      { id: 'ch-7', title: '第七话：决战时刻', number: 7, updatedAt: '2025-07-01', pages: 33 },
      { id: 'ch-8', title: '第八话：新世界', number: 8, updatedAt: '2025-08-01', pages: 28 },
    ],
  },
  {
    id: 'xingkong-zhiyue',
    title: '星空之约',
    author: '苏小暖',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20manga%20cover%20showing%20a%20couple%20standing%20under%20a%20beautiful%20starry%20night%20sky%2C%20cherry%20blossom%20petals%20floating%2C%20soft%20pastel%20colors%20with%20warm%20pink%20and%20golden%20tones%2C%20shoujo%20manga%20art%20style%2C%20dreamy%20atmosphere%2C%20clean%20lines%20and%20sparkle%20effects&width=600&height=800&seq=manga-starry-date&orientation=portrait',
    category: 'lianai',
    status: '已完结',
    description: '高中生小星在暑假遇到了从天而降的神秘少女月儿。两人约定一起看星空，却在相处中逐渐产生了超越友谊的情感。然而月儿身上隐藏着不为人知的秘密——她来自另一个世界。当离别的时刻来临，他们的约定还能实现吗？',
    rating: 9.5,
    views: 1560000,
    tags: ['恋爱', '校园', '奇幻', '治愈'],
    updatedAt: '2026-07-15',
    chapters: [
      { id: 'ch-1', title: '第一话：从天而降的少女', number: 1, updatedAt: '2024-06-01', pages: 28 },
      { id: 'ch-2', title: '第二话：星空下的约定', number: 2, updatedAt: '2024-06-15', pages: 30 },
      { id: 'ch-3', title: '第三话：秘密', number: 3, updatedAt: '2024-07-01', pages: 26 },
      { id: 'ch-4', title: '第四话：夏日祭典', number: 4, updatedAt: '2024-07-20', pages: 32 },
      { id: 'ch-5', title: '第五话：离别的预感', number: 5, updatedAt: '2024-08-10', pages: 29 },
      { id: 'ch-6', title: '第六话：真相', number: 6, updatedAt: '2024-09-01', pages: 31 },
      { id: 'ch-7', title: '第七话：最后的星空', number: 7, updatedAt: '2024-09-20', pages: 33 },
      { id: 'ch-8', title: '第八话：重逢', number: 8, updatedAt: '2024-10-10', pages: 28 },
      { id: 'ch-9', title: '第九话：永恒之约', number: 9, updatedAt: '2024-11-01', pages: 35 },
    ],
  },
  {
    id: 'anhe-diaochayuan',
    title: '暗河调查员',
    author: '墨渊',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20mystery%20manga%20cover%20with%20a%20detective%20in%20a%20trench%20coat%20holding%20a%20flashlight%20in%20a%20foggy%20alley%2C%20noir%20atmosphere%2C%20warm%20sepia%20and%20dark%20brown%20tones%2C%20mysterious%20silhouette%20in%20the%20background%2C%20suspenseful%20manga%20art%20style%2C%20dramatic%20shadows%20and%20lighting&width=600&height=800&seq=manga-dark-river&orientation=portrait',
    category: 'xuanyi',
    status: '连载中',
    description: '退休刑警老陈被卷入一系列离奇案件。每当他以为找到了真相，却发现背后隐藏着更深的谜团。暗河——这座城市的地下组织，正悄然浮出水面。在谎言与真相的漩涡中，老陈能否揭开暗河的真面目？',
    rating: 9.2,
    views: 623000,
    tags: ['悬疑', '推理', '都市', '犯罪'],
    updatedAt: '2026-08-02',
    chapters: [
      { id: 'ch-1', title: '第一话：退休', number: 1, updatedAt: '2025-05-01', pages: 34 },
      { id: 'ch-2', title: '第二话：第一案', number: 2, updatedAt: '2025-05-20', pages: 30 },
      { id: 'ch-3', title: '第三话：蛛丝马迹', number: 3, updatedAt: '2025-06-15', pages: 28 },
      { id: 'ch-4', title: '第四话：暗河浮现', number: 4, updatedAt: '2025-07-10', pages: 32 },
      { id: 'ch-5', title: '第五话：证人', number: 5, updatedAt: '2025-08-01', pages: 29 },
      { id: 'ch-6', title: '第六话：逆转', number: 6, updatedAt: '2025-09-01', pages: 35 },
    ],
  },
  {
    id: 'shikong-lieche',
    title: '时空列车',
    author: '周远',
    cover: 'https://readdy.ai/api/search-image?query=A%20sci-fi%20manga%20cover%20depicting%20a%20futuristic%20train%20traveling%20through%20a%20wormhole%20in%20space%2C%20glowing%20neon%20lights%2C%20clock%20gears%20floating%2C%20warm%20orange%20and%20teal%20color%20scheme%2C%20steampunk%20and%20sci-fi%20fusion%20style%2C%20dynamic%20composition%20with%20motion%20lines&width=600&height=800&seq=manga-time-train&orientation=portrait',
    category: 'kehuan',
    status: '连载中',
    description: '一列神秘的列车穿梭在不同时空中。乘客们来自各个时代，他们登上列车的原因各不相同——有人想改变过去，有人想窥探未来。但当列车长宣布"终点站是世界的尽头"时，所有人都必须在旅途中做出选择。',
    rating: 9.4,
    views: 912000,
    tags: ['科幻', '冒险', '悬疑', '哲学'],
    updatedAt: '2026-08-03',
    chapters: [
      { id: 'ch-1', title: '第一话：车票', number: 1, updatedAt: '2025-08-01', pages: 30 },
      { id: 'ch-2', title: '第二话：第一位乘客', number: 2, updatedAt: '2025-08-20', pages: 28 },
      { id: 'ch-3', title: '第三话：过去的车站', number: 3, updatedAt: '2025-09-15', pages: 32 },
      { id: 'ch-4', title: '第四话：未来的风景', number: 4, updatedAt: '2025-10-10', pages: 29 },
      { id: 'ch-5', title: '第五话：列车长的秘密', number: 5, updatedAt: '2025-11-01', pages: 34 },
      { id: 'ch-6', title: '第六话：终点的预感', number: 6, updatedAt: '2025-12-01', pages: 31 },
      { id: 'ch-7', title: '第七话：选择', number: 7, updatedAt: '2026-01-10', pages: 33 },
      { id: 'ch-8', title: '第八话：世界的尽头', number: 8, updatedAt: '2026-02-20', pages: 28 },
    ],
  },
  {
    id: 'shendiao-gag',
    title: '神雕搞怪传',
    author: '笑三少',
    cover: 'https://readdy.ai/api/search-image?query=A%20funny%20comedy%20manga%20cover%20with%20a%20chibi-style%20martial%20artist%20and%20a%20goofy-looking%20eagle%2C%20exaggerated%20facial%20expressions%2C%20bright%20warm%20colors%20with%20orange%20and%20yellow%20tones%2C%20humorous%20illustration%20style%2C%20comic%20sound%20effects%20in%20speech%20bubbles%2C%20playful%20manga%20art&width=600&height=800&seq=manga-gag-eagle&orientation=portrait',
    category: 'gaoxiao',
    status: '连载中',
    description: '如果经典武侠故事中的人物都是活宝怎么办？神雕搞怪传带给你一个完全颠覆的武侠世界！杨小过是个只会耍宝的废柴，神雕其实是只爱吐槽的毒舌鸟。他们组成的"最强"组合，将如何在这个江湖中搞出一片天？',
    rating: 9.1,
    views: 1105000,
    tags: ['搞笑', '武侠', '日常', '恶搞'],
    updatedAt: '2026-08-01',
    chapters: [
      { id: 'ch-1', title: '第一话：废柴出山', number: 1, updatedAt: '2025-09-01', pages: 24 },
      { id: 'ch-2', title: '第二话：毒舌神雕', number: 2, updatedAt: '2025-09-15', pages: 26 },
      { id: 'ch-3', title: '第三话：江湖第一坑', number: 3, updatedAt: '2025-10-01', pages: 22 },
      { id: 'ch-4', title: '第四话：师徒互坑', number: 4, updatedAt: '2025-10-20', pages: 28 },
      { id: 'ch-5', title: '第五话：奇葩大会', number: 5, updatedAt: '2025-11-10', pages: 25 },
    ],
  },
  {
    id: 'yinying-zhi-cheng',
    title: '阴影之城',
    author: '暗夜行',
    cover: 'https://readdy.ai/api/search-image?query=A%20horror%20manga%20cover%20showing%20an%20abandoned%20cityscape%20shrouded%20in%20darkness%2C%20eerie%20red%20eyes%20glowing%20in%20the%20shadows%2C%20foggy%20atmosphere%2C%20dark%20warm%20sepia%20and%20crimson%20tones%2C%20psychological%20horror%20manga%20style%2C%20ominous%20silhouettes%2C%20distorted%20perspective&width=600&height=800&seq=manga-shadow-city&orientation=portrait',
    category: 'kongbu',
    status: '已完结',
    description: '搬入新城市的林小晚发现，每当夜幕降临，城市的阴影中就会出现不为人知的存在。邻居们神秘失踪、楼道里奇怪的脚步声、镜中多出来的倒影……真相远比她想象的更加恐怖。',
    rating: 9.0,
    views: 745000,
    tags: ['恐怖', '悬疑', '都市', '灵异'],
    updatedAt: '2026-06-30',
    chapters: [
      { id: 'ch-1', title: '第一话：新家', number: 1, updatedAt: '2024-12-01', pages: 30 },
      { id: 'ch-2', title: '第二话：邻居', number: 2, updatedAt: '2024-12-20', pages: 28 },
      { id: 'ch-3', title: '第三话：脚步声', number: 3, updatedAt: '2025-01-15', pages: 32 },
      { id: 'ch-4', title: '第四话：镜子', number: 4, updatedAt: '2025-02-10', pages: 29 },
      { id: 'ch-5', title: '第五话：失踪', number: 5, updatedAt: '2025-03-01', pages: 26 },
      { id: 'ch-6', title: '第六话：真相', number: 6, updatedAt: '2025-04-01', pages: 35 },
      { id: 'ch-7', title: '第七话：逃离', number: 7, updatedAt: '2025-05-01', pages: 31 },
      { id: 'ch-8', title: '第八话：黎明', number: 8, updatedAt: '2025-06-01', pages: 28 },
    ],
  },
  {
    id: 'yanhuo-shijian',
    title: '烟火人间',
    author: '陈默',
    cover: 'https://readdy.ai/api/search-image?query=A%20slice-of-life%20manga%20cover%20depicting%20a%20young%20chef%20cooking%20in%20a%20warm%20kitchen%2C%20steam%20rising%20from%20pots%2C%20golden%20evening%20light%20through%20the%20window%2C%20cozy%20atmosphere%2C%20warm%20orange%20and%20cream%20color%20palette%2C%20gentle%20manga%20art%20style%2C%20detailed%20food%20illustrations&width=600&height=800&seq=manga-fireworks-life&orientation=portrait',
    category: 'rexue',
    status: '连载中',
    description: '在繁忙都市的小巷深处，有一家只在深夜营业的小餐馆。老板阿言不善言辞，却能用一道菜治愈每个疲惫的灵魂。每个夜晚，不同的客人带着不同的故事来到这里。烟火人间，温暖常在。',
    rating: 9.7,
    views: 1340000,
    tags: ['美食', '治愈', '日常', '都市'],
    updatedAt: '2026-08-04',
    chapters: [
      { id: 'ch-1', title: '第一话：深夜食堂', number: 1, updatedAt: '2025-11-01', pages: 26 },
      { id: 'ch-2', title: '第二话：加班族的蛋炒饭', number: 2, updatedAt: '2025-11-15', pages: 28 },
      { id: 'ch-3', title: '第三话：失恋的味增汤', number: 3, updatedAt: '2025-12-01', pages: 25 },
      { id: 'ch-4', title: '第四话：父亲的糖醋排骨', number: 4, updatedAt: '2025-12-20', pages: 30 },
      { id: 'ch-5', title: '第五话：初雪和关东煮', number: 5, updatedAt: '2026-01-10', pages: 27 },
      { id: 'ch-6', title: '第六话：团圆的饺子', number: 6, updatedAt: '2026-02-01', pages: 29 },
      { id: 'ch-7', title: '第七话：春天的野菜', number: 7, updatedAt: '2026-03-01', pages: 26 },
      { id: 'ch-8', title: '第八话：妈妈的 recipe', number: 8, updatedAt: '2026-04-01', pages: 31 },
      { id: 'ch-9', title: '第九话：夏夜的凉面', number: 9, updatedAt: '2026-05-01', pages: 28 },
      { id: 'ch-10', title: '第十话：客人的故事', number: 10, updatedAt: '2026-06-01', pages: 30 },
      { id: 'ch-11', title: '第十一话：重逢', number: 11, updatedAt: '2026-07-01', pages: 33 },
      { id: 'ch-12', title: '第十二话：永远为你开门', number: 12, updatedAt: '2026-08-04', pages: 28 },
    ],
  },
];

export const mockReviews = [
  { author: '小明同学', rating: 5, content: '洞洞杂货铺真的太好看了！每个故事都温暖人心，画风也很舒服，强烈推荐！', date: '2026-08-01' },
  { author: '漫画爱好者', rating: 5, content: '在这里免费看了好多漫画，更新也很快，比别的网站好用多了。', date: '2026-07-28' },
  { author: '小猫咪', rating: 4, content: '烟火人间每话都看哭了，太治愈了。推荐给所有需要温暖的人。', date: '2026-07-25' },
  { author: '追风少年', rating: 5, content: '时空列车的设定太酷了！每画都让人意想不到，期待后续发展！', date: '2026-07-20' },
  { author: '夜空守望者', rating: 5, content: '星空之约已经全部追完了，很感动。希望作者能出番外篇！', date: '2026-07-18' },
  { author: '读书人', rating: 4, content: '界面简洁，加载速度快，用手机看漫画体验很棒。收藏了！', date: '2026-07-15' },
  { author: '王大锤', rating: 5, content: '神雕搞怪传感笑死我了，上班摸鱼必备！每集都笑出腹肌。', date: '2026-07-10' },
  { author: '推理迷', rating: 5, content: '暗河调查员的推理情节设计得很精妙，完全猜不到结局！', date: '2026-07-05' },
];